import { LockOutlined } from "@ant-design/icons"
import { Tooltip } from "antd"
import React from "react"

interface Props extends React.ComponentProps<typeof LockOutlined> {
  text?: string
}

export const RestrictedIcon = (props: Props) => {
  const {
   text: propsText,
   ...iconProps
  } = props

  const component = (
    <LockOutlined
      style={{
        ...iconProps.style,
        margin: '5px',
        cursor: 'pointer',
      }}
      {...iconProps}
    />
  )

  const text = "Only visible to team members with the necessary permissions."

  if (text) {
    return (
      <Tooltip title={text}>
        {component}
      </Tooltip>
    )
  } else {
    return component
  }
}